webpackJsonp([19],{

/***/ 124:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_swiper__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_swiper__);





var html = function html(val) {
  return val.map(function (each) {
    return '\n  <li class="m-showcase__item m-searchShowcase__item">\n    <a class="m-detailShowcase__itemInner" href="/styles/' + each.style_key + '/designs/' + each.design_id + '/preview/">\n      <div class="a-card--noShadow m-detailShowcase__surface">\n        <span class="a-card--noShadow__inner m-detailShowcase__cardInner">\n          <img src="/assets/img/banner/templates/list/' + each.image_style_key + '_' + each.design_id + '.png" srcset="/assets/img/banner/templates/list/' + each.image_style_key + '_' + each.design_id + '@2x.png 2x" width="' + each.width + '" height="' + each.height + '" >\n        </span>\n      </div>\n    </a>\n    <div class="m-searchShowcase__item__info">\n      ' + checkPopular(each.is_popular) + '<span class="m-searchShowcase__item__info__title">' + each.design_name + '</span>\n      <div class="a-favorite m-searchShowcase__item__info__fav js-favorite ' + checkFavorite(each.favorite) + '" data-favorite="' + each.style_key + '@' + each.design_id + '"></div>\n    </div>\n    ' + detailLink(each.style_key, each.design_id) + '\n  </li>\n  ';
  }).join('') + '\n';
};

var posterHtml = function posterHtml(val) {
  return val.map(function (each) {
    return '\n  <li class="m-showcase__item m-searchShowcase__item">\n    <a class="m-detailShowcase__itemInner" href="/styles/' + each.style_key + '/designs/' + each.design_id + '/preview/">\n      <div class="a-card--noShadow m-detailShowcase__surface">\n        <span class="a-card--noShadow__inner m-detailShowcase__cardInner">\n          <img src="/assets/img/banner/templates/list/' + each.image_style_key + '_' + each.design_id + '.png" srcset="/assets/img/banner/templates/list/' + each.image_style_key + '_' + each.design_id + '@2x.png 2x" width="344" height="344" >\n        </span>\n      </div>\n    </a>\n    <div class="m-searchShowcase__item__info">\n      ' + checkPopular(each.is_popular) + '<span class="m-searchShowcase__item__info__title">' + each.design_name + '</span>\n      <div class="a-favorite m-searchShowcase__item__info__fav js-favorite ' + checkFavorite(each.favorite) + '" data-favorite="' + each.style_key + '@' + each.design_id + '"></div>\n    </div>\n    ' + detailLink(each.style_key, each.design_id) + '\n  </li>\n  ';
  }).join('') + '\n';
};

var sealHtml = function sealHtml(val) {
  return val.map(function (each) {
    return '\n  <li class="m-showcase__item m-searchShowcase__sealItem">\n    <a class="m-detailShowcase__itemInner" href="/styles/' + each.style_key + '/designs/' + each.design_id + '/preview/">\n      <div class="a-card--noShadow m-detailShowcase__surface">\n        <span class="a-card--noShadow__inner m-detailShowcase__cardInner m-searchShowcase__sealItem__inner">\n          <img src="/assets/img/banner/templates/list/' + each.image_style_key + '_' + each.design_id + '.png" srcset="/assets/img/banner/templates/list/' + each.image_style_key + '_' + each.design_id + '@2x.png 2x" width="' + each.width + '" height="' + each.height + '" >\n        </span>\n      </div>\n    </a>\n    <div class="m-searchShowcase__item__info">\n      ' + checkPopular(each.is_popular) + '<span class="m-searchShowcase__item__info__title">' + each.design_name + '</span>\n      <div class="a-favorite m-searchShowcase__item__info__fav js-favorite ' + checkFavorite(each.favorite) + '" data-favorite="' + each.style_key + '@' + each.design_id + '"></div>\n    </div>\n    ' + detailLink(each.style_key, each.design_id) + '\n  </li>\n  ';
  }).join('') + '\n';
};

var checkFavorite = function checkFavorite(v) {
  if (v === '1') {
    return 'is-active';
  }
  return '';
};

var detailLink = function detailLink(key, id) {
  if (key !== 'pics' && key !== 'neon' && key !== 'dark') {
    return '<div class="m-searchShowcase__item__link"><a class="a-arrowLinkBule--M" href="/styles/' + key + '/designs/' + id + '/">\u8A73\u7D30\u3092\u307F\u308B</a></div>';
  }
  return '';
};

var checkPopular = function checkPopular(v) {
  if (v === '1') {
    return '<img class="m-searchShowcase__item__info__popular" src="/assets/img/icon/icon-popular.svg">';
  }
  return '';
};

function refreshResultView() {
  var isAnimate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

  __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-DesignsForm').ajaxSubmit({
    url: '',
    dataType: 'json',
    success: function success(response, statusText) {
      if (response.categoryKey === 'card') {
        __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-ShowCase').html(html(response.designs));
      } else if (response.categoryKey === 'poster') {
        __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-ShowCase').html(posterHtml(response.designs));
      } else if (response.categoryKey === 'seal' || response.categoryKey === 'envelope' || response.categoryKey === 'leaflet') {
        __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-ShowCase').html(sealHtml(response.designs));
      } else {
        __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-ShowCase').html(html(response.designs));
      }
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-pager').html(response.pager);
      if (isAnimate) {
        __WEBPACK_IMPORTED_MODULE_1_jquery___default()('html, body').animate({ scrollTop: __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-styleList').offset().top }, 500, 'swing');
      }
      window.Ts.reload();
    }
  });
}

var inputDesignName = function inputDesignName() {
  __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-DesignName').on('keydown', '', function (e) {
    if (e.which && e.which === 13 || e.keyCode && e.keyCode === 13) {
      return false;
    }
    return true;
  });

  var timer = void 0;

  __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-DesignName').on('focus', '', function () {
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-DesignName').data('past-text', __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-DesignName').val());
    timer = setInterval(function () {
      if (__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-DesignName').val() !== __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-DesignName').data('past-text')) {
        __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-DesignName').data('past-text', __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-DesignName').val());
        __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-pageValue').val('');
        refreshResultView(false);
      }
    }, 2000);
  });

  __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-DesignName').on('blur', '', function () {
    clearInterval(timer);
  });
};

var clickSize = function clickSize() {
  __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-Size').on('click', '', function () {
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-pageValue').val('');
    refreshResultView();
  });
};

var clickTagPersons = function clickTagPersons() {
  __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-TagPersons').on('click', '', function () {
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-pageValue').val('');
    refreshResultView();
  });
};

var clickTagTaste = function clickTagTaste() {
  __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-TagTaste').on('click', '', function () {
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-pageValue').val('');
    refreshResultView();
  });
};

var clickTagPicture = function clickTagPicture() {
  __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-TagPicture').on('click', '', function () {
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-pageValue').val('');
    refreshResultView();
  });
};

var clickColor = function clickColor() {
  __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-Color').on('click', function () {
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-pageValue').val('');
    refreshResultView();
  });
};

var clickFavorite = function clickFavorite() {
  __WEBPACK_IMPORTED_MODULE_1_jquery___default()(document).on('click', '.js-favorite', function (e) {
    var target = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(e.target);
    var designId = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(e.target).data('favorite');
    if (designId !== '') {
      var url = '/api/template_favorite/';
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(url, { design_id: designId }).then(function (res) {
        var json = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(res.data));
        if (json.status === '1') {
          if (target.hasClass('is-active')) {
            target.removeClass('is-active');
          } else {
            target.addClass('is-active');
          }
        } else {
          target.removeClass('is-active');
        }
      });
    }
    return false;
  });
};

var clickPager = function clickPager() {
  __WEBPACK_IMPORTED_MODULE_1_jquery___default()(document).on('click', '.js-pager', function (e) {
    if (!__WEBPACK_IMPORTED_MODULE_1_jquery___default()(e.target).hasClass('is-disable')) {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-pageValue').val(__WEBPACK_IMPORTED_MODULE_1_jquery___default()(e.target).data('page'));
      refreshResultView();
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()('html, body').animate({ scrollTop: __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-styleList').offset().top }, 500, 'swing');
    }
  });
};

var slideStartNum = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-designStyle').length - 1;

var clickTermPC = function clickTermPC() {
  __WEBPACK_IMPORTED_MODULE_1_jquery___default()(document).on('click', '.js-termName', function (e) {
    var $target = void 0;
    if (__WEBPACK_IMPORTED_MODULE_1_jquery___default()(e.target).hasClass('js-termName')) {
      $target = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(e.target);
    } else {
      $target = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(e.target).closest('.js-termName');
    }
    var termName = $target.data('term');
    if (!$target.hasClass('is-choice')) {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-termName').removeClass('is-choice');
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()('[class*="js-termModal-"]').removeClass('is-choice');
      $target.addClass('is-choice');
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-termModal-' + termName).addClass('is-choice');
    } else {
      $target.removeClass('is-choice');
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-termModal-' + termName).removeClass('is-choice');
    }
  });
};

var clickTermSP = function clickTermSP() {
  __WEBPACK_IMPORTED_MODULE_1_jquery___default()(document).on('click', '.js-designTermName', function (e) {
    var $target = void 0;
    if (__WEBPACK_IMPORTED_MODULE_1_jquery___default()(e.target).hasClass('js-designTermName')) {
      $target = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(e.target);
    } else {
      $target = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(e.target).closest('.js-designTermName');
    }
    var termName = $target.data('term');
    var $modal = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-termModal-' + termName);
    var winWidth = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(window).width();
    var offset = $target.offset();
    var $attach = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-termDescAttach');
    if (!$target.hasClass('is-choice')) {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-designTermName').removeClass('is-choice');
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()('[class*="js-termModal-"]').removeClass('is-choice');
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-termDescAttach').removeClass('is-choice');
      $target.addClass('is-choice');

      if (winWidth - ($modal.width() + offset.left) >= 0) {
        $modal.addClass('is-choice').css({
          top: offset.top + 40 + 'px',
          left: offset.left + 'px',
          right: 'auto'
        });
      } else {
        $modal.addClass('is-choice').css({
          top: offset.top + 40 + 'px',
          left: 'auto',
          right: 0
        });
      }
      console.log($attach.width());
      if (winWidth - (134 + offset.left) >= 0) {
        $attach.css({
          width: 134 + 'px'
        });
      } else {
        $attach.css({
          width: 134 + (winWidth - (134 + offset.left + 2)) + 'px'
        });
      }
      $attach.addClass('is-choice').css({
        top: offset.top + 29 + 'px',
        left: offset.left + 1 + 'px'
      });
    } else {
      $target.removeClass('is-choice');
      $modal.removeClass('is-choice');
      $attach.removeClass('is-choice');
    }
  });
};

var termSlidePaging = function termSlidePaging() {
  __WEBPACK_IMPORTED_MODULE_1_jquery___default()(document).on('click', '.js-termPrev, .js-termNext', function () {
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-designTermName').removeClass('is-choice');
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()('[class*="js-termModal-"]').removeClass('is-choice');
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-termDescAttach').removeClass('is-choice');
  });
};

__WEBPACK_IMPORTED_MODULE_1_jquery___default()(function () {
  inputDesignName();
  clickSize();
  clickTagPersons();
  clickTagTaste();
  clickTagPicture();
  clickColor();
  clickPager();
  clickFavorite();
  refreshResultView();
  __WEBPACK_IMPORTED_MODULE_3_swiper___default()('.js-designStyleList', {
    loop: true,
    speed: 500,
    slidesPerView: 'auto',
    initialSlide: slideStartNum,
    prevButton: '.js-desigPrev',
    nextButton: '.js-designNext',
    hideOnClick: true
  });
  __WEBPACK_IMPORTED_MODULE_3_swiper___default()('.js-termsList-sp', {
    loop: true,
    speed: 500,
    slidesPerView: 'auto',
    initialSlide: 0,
    prevButton: '.js-termPrev',
    nextButton: '.js-termNext',
    hideOnClick: true
  });
  clickTermPC();
  clickTermSP();
  termSlidePaging();
});

/***/ })

},[124]);


// WEBPACK FOOTER //
// assets/js/designs.js